import { Component, Injectable, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { CustomTranslateService } from '@services/common/custom-translate.service';

import { LocalStorageKeys, StorageService } from '@services/storage/storage.service';
import { ConfigService } from 'app/app-config.service';
import { CognitoAuthenticationService } from 'app/auth/service';
import { Observer, first } from 'rxjs';

@Component({
    selector: 'app-language-selector',
    templateUrl: './language-selector.component.html',
    styleUrls: ['./language-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LanguageSelectorComponent implements OnInit {
    public availableLocales: string[];
    @Input() public selectedLocale: string;
    private didChange: boolean;

    constructor(
        private authService: CognitoAuthenticationService,
        private configService: ConfigService,
        private storageService: StorageService,
        private translateService: CustomTranslateService,
    ) {}

    ngOnInit() {
        this.selectedLocale = this.translateService.currentLang;
        this.availableLocales = this.translateService.langs;
        this.translateService.onLangChange.subscribe((ev) => {
            this.selectedLocale = ev.lang;
            // guard clause to avoid infinite recursion.
            if (!this.didChange) this.handleLanguageChange(ev.lang);
            this.didChange = false;
        });
    }

    public handleLanguageChange(locale: string): void {
        this.didChange = true;
        if (!this.authService.authenticatedUser) {
            this.translateService.use(locale);
            this.storageService.setGlobalItem(LocalStorageKeys.localeUser, locale);
        } else {
            this.authService.updateUserLocale(locale).subscribe((observer) => {
                if (observer) {
                    this.translateService.use(locale);
                }
            });
        }
    }
}
